// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/push_rules/v1/push_rules.proto" (package "c1.api.push_rules.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserTargeting
 */
export interface UserTargeting {
    /**
     * @generated from protobuf oneof: target
     */
    target: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.AllUsers all = 1;
         */
        all: AllUsers;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel = 2;
         */
        cel: CelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.AllUsers
 */
export interface AllUsers {
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.CelExpression
 */
export interface CelExpression {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfiguration
 */
export interface UserAttributePushConfiguration {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4;
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: bool allows_custom_attribute_names = 5;
     */
    allowsCustomAttributeNames: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_push_at = 8;
     */
    lastPushAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationRef
 */
export interface UserAttributePushConfigurationRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRule
 */
export interface UserAttributePushRule {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string target_attribute_name = 3;
     */
    targetAttributeName: string;
    /**
     * @generated from protobuf oneof: mapping_rule
     */
    mappingRule: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.None none = 100;
         */
        none: None;
    } | {
        oneofKind: "c1Attribute";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.C1Attribute c1_attribute = 101;
         */
        c1Attribute: C1Attribute;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel_expression = 102;
         */
        celExpression: CelExpression;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool is_custom = 4;
     */
    isCustom: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.None
 */
export interface None {
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.C1Attribute
 */
export interface C1Attribute {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest
 */
export interface UserAttributePushConfigurationServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse
 */
export interface UserAttributePushConfigurationServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1;
     */
    configuration?: UserAttributePushConfiguration;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest
 */
export interface UserAttributePushConfigurationServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4;
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 5;
     */
    updateMask?: FieldMask;
    /**
     * Optional: if provided, rules will be updated atomically with the configuration
     *
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 6;
     */
    rules: UserAttributePushRuleInput[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse
 */
export interface UserAttributePushConfigurationServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1;
     */
    configuration?: UserAttributePushConfiguration;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2;
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest
 */
export interface UserAttributePushConfigurationServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse
 */
export interface UserAttributePushConfigurationServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushConfiguration list = 1;
     */
    list: UserAttributePushConfiguration[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest
 */
export interface UserAttributePushRuleServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 3;
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse
 */
export interface UserAttributePushRuleServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 1;
     */
    rules: UserAttributePushRule[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest
 */
export interface UserAttributePushRuleServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse
 */
export interface UserAttributePushRuleServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule list = 1;
     */
    list: UserAttributePushRule[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest
 */
export interface UserAttributePushConfigurationServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: bool enabled = 3;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserTargeting user_targeting = 4;
     */
    userTargeting?: UserTargeting;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRuleInput rules = 5;
     */
    rules: UserAttributePushRuleInput[];
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse
 */
export interface UserAttributePushConfigurationServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.push_rules.v1.UserAttributePushConfiguration configuration = 1;
     */
    configuration?: UserAttributePushConfiguration;
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.UserAttributePushRule rules = 2;
     */
    rules: UserAttributePushRule[];
}
/**
 * Input for creating a push rule - is_custom is derived by comparing target_attribute_name against the schema
 *
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushRuleInput
 */
export interface UserAttributePushRuleInput {
    /**
     * @generated from protobuf field: string target_attribute_name = 1;
     */
    targetAttributeName: string;
    /**
     * @generated from protobuf oneof: mapping_rule
     */
    mappingRule: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.None none = 100;
         */
        none: None;
    } | {
        oneofKind: "c1Attribute";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.C1Attribute c1_attribute = 101;
         */
        c1Attribute: C1Attribute;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.push_rules.v1.CelExpression cel_expression = 102;
         */
        celExpression: CelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * A pushable attribute from the connector's action schema
 *
 * @generated from protobuf message c1.api.push_rules.v1.PushableAttribute
 */
export interface PushableAttribute {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaRequest
 */
export interface GetConnectorPushSchemaRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaResponse
 */
export interface GetConnectorPushSchemaResponse {
    /**
     * @generated from protobuf field: repeated c1.api.push_rules.v1.PushableAttribute attributes = 1;
     */
    attributes: PushableAttribute[];
    /**
     * @generated from protobuf field: bool allows_custom_attributes = 2;
     */
    allowsCustomAttributes: boolean;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest
 */
export interface UserAttributePushConfigurationServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse
 */
export interface UserAttributePushConfigurationServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class UserTargeting$Type extends MessageType<UserTargeting> {
    constructor() {
        super("c1.api.push_rules.v1.UserTargeting", [
            { no: 1, name: "all", kind: "message", oneof: "target", T: () => AllUsers },
            { no: 2, name: "cel", kind: "message", oneof: "target", T: () => CelExpression }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserTargeting
 */
export const UserTargeting = new UserTargeting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllUsers$Type extends MessageType<AllUsers> {
    constructor() {
        super("c1.api.push_rules.v1.AllUsers", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.AllUsers
 */
export const AllUsers = new AllUsers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CelExpression$Type extends MessageType<CelExpression> {
    constructor() {
        super("c1.api.push_rules.v1.CelExpression", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.CelExpression
 */
export const CelExpression = new CelExpression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfiguration$Type extends MessageType<UserAttributePushConfiguration> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfiguration", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "allows_custom_attribute_names", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "last_push_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfiguration
 */
export const UserAttributePushConfiguration = new UserAttributePushConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationRef$Type extends MessageType<UserAttributePushConfigurationRef> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationRef
 */
export const UserAttributePushConfigurationRef = new UserAttributePushConfigurationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRule$Type extends MessageType<UserAttributePushRule> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRule", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "target_attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 100, name: "none", kind: "message", oneof: "mappingRule", T: () => None },
            { no: 101, name: "c1_attribute", kind: "message", oneof: "mappingRule", T: () => C1Attribute },
            { no: 102, name: "cel_expression", kind: "message", oneof: "mappingRule", T: () => CelExpression },
            { no: 4, name: "is_custom", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRule
 */
export const UserAttributePushRule = new UserAttributePushRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class None$Type extends MessageType<None> {
    constructor() {
        super("c1.api.push_rules.v1.None", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.None
 */
export const None = new None$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1Attribute$Type extends MessageType<C1Attribute> {
    constructor() {
        super("c1.api.push_rules.v1.C1Attribute", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.C1Attribute
 */
export const C1Attribute = new C1Attribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceGetRequest$Type extends MessageType<UserAttributePushConfigurationServiceGetRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetRequest
 */
export const UserAttributePushConfigurationServiceGetRequest = new UserAttributePushConfigurationServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceGetResponse$Type extends MessageType<UserAttributePushConfigurationServiceGetResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceGetResponse
 */
export const UserAttributePushConfigurationServiceGetResponse = new UserAttributePushConfigurationServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceUpdateRequest$Type extends MessageType<UserAttributePushConfigurationServiceUpdateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 6, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRuleInput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateRequest
 */
export const UserAttributePushConfigurationServiceUpdateRequest = new UserAttributePushConfigurationServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceUpdateResponse$Type extends MessageType<UserAttributePushConfigurationServiceUpdateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration },
            { no: 2, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceUpdateResponse
 */
export const UserAttributePushConfigurationServiceUpdateResponse = new UserAttributePushConfigurationServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceListRequest$Type extends MessageType<UserAttributePushConfigurationServiceListRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListRequest
 */
export const UserAttributePushConfigurationServiceListRequest = new UserAttributePushConfigurationServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceListResponse$Type extends MessageType<UserAttributePushConfigurationServiceListResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushConfiguration },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceListResponse
 */
export const UserAttributePushConfigurationServiceListResponse = new UserAttributePushConfigurationServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceUpdateRequest$Type extends MessageType<UserAttributePushRuleServiceUpdateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateRequest
 */
export const UserAttributePushRuleServiceUpdateRequest = new UserAttributePushRuleServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceUpdateResponse$Type extends MessageType<UserAttributePushRuleServiceUpdateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse", [
            { no: 1, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceUpdateResponse
 */
export const UserAttributePushRuleServiceUpdateResponse = new UserAttributePushRuleServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceListRequest$Type extends MessageType<UserAttributePushRuleServiceListRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListRequest
 */
export const UserAttributePushRuleServiceListRequest = new UserAttributePushRuleServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleServiceListResponse$Type extends MessageType<UserAttributePushRuleServiceListResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleServiceListResponse
 */
export const UserAttributePushRuleServiceListResponse = new UserAttributePushRuleServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceCreateRequest$Type extends MessageType<UserAttributePushConfigurationServiceCreateRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_targeting", kind: "message", T: () => UserTargeting },
            { no: 5, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRuleInput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateRequest
 */
export const UserAttributePushConfigurationServiceCreateRequest = new UserAttributePushConfigurationServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceCreateResponse$Type extends MessageType<UserAttributePushConfigurationServiceCreateResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse", [
            { no: 1, name: "configuration", kind: "message", T: () => UserAttributePushConfiguration },
            { no: 2, name: "rules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributePushRule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceCreateResponse
 */
export const UserAttributePushConfigurationServiceCreateResponse = new UserAttributePushConfigurationServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushRuleInput$Type extends MessageType<UserAttributePushRuleInput> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushRuleInput", [
            { no: 1, name: "target_attribute_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 100, name: "none", kind: "message", oneof: "mappingRule", T: () => None },
            { no: 101, name: "c1_attribute", kind: "message", oneof: "mappingRule", T: () => C1Attribute },
            { no: 102, name: "cel_expression", kind: "message", oneof: "mappingRule", T: () => CelExpression }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushRuleInput
 */
export const UserAttributePushRuleInput = new UserAttributePushRuleInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushableAttribute$Type extends MessageType<PushableAttribute> {
    constructor() {
        super("c1.api.push_rules.v1.PushableAttribute", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.PushableAttribute
 */
export const PushableAttribute = new PushableAttribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorPushSchemaRequest$Type extends MessageType<GetConnectorPushSchemaRequest> {
    constructor() {
        super("c1.api.push_rules.v1.GetConnectorPushSchemaRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaRequest
 */
export const GetConnectorPushSchemaRequest = new GetConnectorPushSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorPushSchemaResponse$Type extends MessageType<GetConnectorPushSchemaResponse> {
    constructor() {
        super("c1.api.push_rules.v1.GetConnectorPushSchemaResponse", [
            { no: 1, name: "attributes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushableAttribute },
            { no: 2, name: "allows_custom_attributes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.GetConnectorPushSchemaResponse
 */
export const GetConnectorPushSchemaResponse = new GetConnectorPushSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceDeleteRequest$Type extends MessageType<UserAttributePushConfigurationServiceDeleteRequest> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteRequest
 */
export const UserAttributePushConfigurationServiceDeleteRequest = new UserAttributePushConfigurationServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributePushConfigurationServiceDeleteResponse$Type extends MessageType<UserAttributePushConfigurationServiceDeleteResponse> {
    constructor() {
        super("c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.push_rules.v1.UserAttributePushConfigurationServiceDeleteResponse
 */
export const UserAttributePushConfigurationServiceDeleteResponse = new UserAttributePushConfigurationServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.push_rules.v1.UserAttributePushConfigurationService
 */
export const UserAttributePushConfigurationService = new ServiceType("c1.api.push_rules.v1.UserAttributePushConfigurationService", [
    { name: "CreateUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceCreateRequest, O: UserAttributePushConfigurationServiceCreateResponse },
    { name: "GetUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceGetRequest, O: UserAttributePushConfigurationServiceGetResponse },
    { name: "UpdateUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceUpdateRequest, O: UserAttributePushConfigurationServiceUpdateResponse },
    { name: "ListUserAttributePushConfigurations", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceListRequest, O: UserAttributePushConfigurationServiceListResponse },
    { name: "DeleteUserAttributePushConfiguration", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushConfigurationServiceDeleteRequest, O: UserAttributePushConfigurationServiceDeleteResponse },
    { name: "GetConnectorPushSchema", options: { "authz.method": { role: "OWNER" } }, I: GetConnectorPushSchemaRequest, O: GetConnectorPushSchemaResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.push_rules.v1.UserAttributePushRuleService
 */
export const UserAttributePushRuleService = new ServiceType("c1.api.push_rules.v1.UserAttributePushRuleService", [
    { name: "ListUserAttributePushRules", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushRuleServiceListRequest, O: UserAttributePushRuleServiceListResponse },
    { name: "UpdateUserAttributePushRules", options: { "authz.method": { role: "OWNER" } }, I: UserAttributePushRuleServiceUpdateRequest, O: UserAttributePushRuleServiceUpdateResponse }
]);
